import React from 'react';
import { Help } from '../../logic/components';

const HelpRoute = () => {
  return <Help />;
};

export default React.memo(HelpRoute);
